var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1.5542,
    width: 2,
    height: 22.7717,
    transform: "rotate(-51 0 1.5542)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0935 11.3933C14.232 10.6885 14.99 9.42815 14.99 7.98999C14.99 5.77999 13.2 3.98999 10.99 3.98999V5.98999C12.1 5.98999 12.99 6.87999 12.99 7.98999C12.99 8.98461 12.2674 9.80258 11.3258 9.96189L13.0935 11.3933ZM14.7 12.6943C16.089 11.5976 16.98 9.89853 16.98 7.98999C16.98 4.67999 14.3 2 10.99 2V0C15.4 0 18.98 3.57999 18.98 7.98999C18.98 10.3713 17.9362 12.5106 16.2814 13.9749L14.7 12.6943ZM8.99001 8.07043V0.5C8.99001 0.22 8.83 0.149996 8.62 0.339996L4.24225 4.22577L8.99001 8.07043ZM2.02031 5L8.99001 10.6439V15.48C8.99001 15.75 8.81999 15.83 8.62 15.65L3.37 10.99H0.5C0.23 10.99 0 10.77 0 10.49V5.5C0 5.23 0.22 5 0.5 5H2.02031ZM12.7758 13.7096L14.5482 15.1448C13.4764 15.6793 12.2681 15.98 10.99 15.98V13.98C11.6121 13.98 12.2119 13.8853 12.7758 13.7096Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.d17b2927.svg";
export { ForwardRef as ReactComponent };